import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetStudentNewAnswersQuery } from '../../slices/students/questionsApiSlice';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import NewAnswer2 from '../../components/NewAnswer2';
import NoAnswer from '../../components/NoAnswer';
import PaginateNewAnswers from '../../components/PaginateNewAnswers';
import { colors13 } from '../../colorConstant';
import NewQuestion2 from '../../components/NewQuestion2';

const StudentNewAnswer2 = () => {

    const navigate = useNavigate();

    const { pageNumber } = useParams();
    
    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }   
    }, [navigate, studentInfo])

    const { data, isLoading, error } = useGetStudentNewAnswersQuery({pageNumber})

    return (
        <div>
        <StudentNavbar />
            <div className="main-content " id="panel">
            <StudentHeader /><br /><br /><br />
                <div className="container-fluid mt--6">
                {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (                    
                    <div className="row">                    
                        <h5 className="centerTitle tittleColor4 qFstudents2">
                                <span className='tittleColor4 qFstudents'>
                                {data?.count} New Answers 
                                </span>
                        </h5><br /><br />
                        <div className="offset-xl-1 col-xl-10  ">   
                                <div className="newqBody">
                                <div className=" col-xl-12 ">   
                                    <div className="card timeline23">                
                                        <div className="card-body timeDown"><br />
                                            <div className="timeline22 item-container" data-timeline-content="axis" data-timeline-axis-style="dotted">  
                                                {data?.newanswers?.map((answer, index) => (                        
                                                    <div className='timeline-block timeP2 item' key={answer._id} >  
                                                        <NewAnswer2  answer={answer} color={colors13[index]}  />                    
                                                    </div>
                                                ))}      
                                                {data?.newanswers.length == 0 && (
                                                    <div className="col-md-6 col-xl-4 ">  
                                                        <NoAnswer />                    
                                                    </div>
                                                )}
                                            </div>                                            
                                        </div>                                        
                                        <PaginateNewAnswers
                                            pages={data?.pages}
                                            page={data?.page}
                                            link='studentnewanswer'
                                            className='pagCenterStudent'                                                
                                        />
                                    </div>
                                </div>
                                </div>   
                            </div>  
                    </div>
                )} 
                </div>
            </div>
        </div>
    )
}

export default StudentNewAnswer2